export default function LockIcon() {
  return <i className="bi bi-lock-fill"></i>;
}
